import React from 'react'

type Props = {
  children: React.ReactNode
}

const Badge = ({ children }: Props) => {
  return (
    <div className="bg-gray-100 text-gray-1100 leading-tight flex-shrink-0 px-2 py-1 rounded-md cursor-pointer">
      {children}
    </div>
  )
}

export default Badge
